import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../UI/SectionHeading';
import { SKILL_GROUPS, ROLES, LANGUAGES } from '../../constants';

const Skills: React.FC = () => {
  return (
    <section id='skills' className='scroll-mt-20 max-w-7xl mx-auto px-5 sm:px-6'>
      <SectionHeading
        index='03'
        kicker='Capabilities'
        title='One person, many hats'
        description='Finance fundamentals, hands-on tooling and the banking domain context to ship change end-to-end.'
      />

      {/* Role chips */}
      <div className='flex flex-wrap gap-2 mb-14'>
        {ROLES.map((role, i) => (
          <motion.span
            key={role}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.45, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            className='px-4 py-3 rounded-full border border-line text-sm font-medium text-ink hover:bg-ink hover:text-paper hover:border-ink transition-colors duration-300'
            data-cursor='pointer'
          >
            {role}
          </motion.span>
        ))}
      </div>

      {/* Skill groups as list rows */}
      <div className='border-t border-line'>
        {SKILL_GROUPS.map((group, gi) => (
          <motion.div
            key={group.title}
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.55, delay: gi * 0.06, ease: [0.16, 1, 0.3, 1] }}
            className='group grid grid-cols-1 sm:grid-cols-[220px_1fr] lg:grid-cols-[300px_1fr] gap-3 sm:gap-8 py-8 border-b border-line'
          >
            <div className='flex items-start gap-3'>
              <span className='label-mono text-gray2 mt-1.5'>
                {String(gi + 1).padStart(2, '0')}
              </span>
              <h3 className='font-medium tracking-tight text-lg text-ink group-hover:translate-x-1 transition-transform duration-400'>
                {group.title}
              </h3>
            </div>
            <div className='flex flex-wrap gap-x-6 gap-y-2'>
              {group.items.map(item => (
                <span
                  key={item}
                  className='text-sm text-gray1 hover:text-accent transition-colors duration-300'
                >
                  {item}
                </span>
              ))}
            </div>
          </motion.div>
        ))}

        {/* Languages */}
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className='grid grid-cols-1 sm:grid-cols-[220px_1fr] lg:grid-cols-[300px_1fr] gap-3 sm:gap-8 py-8 border-b border-line'
        >
          <div className='flex items-start gap-3'>
            <span className='label-mono text-gray2 mt-1.5'>
              {String(SKILL_GROUPS.length + 1).padStart(2, '0')}
            </span>
            <h3 className='font-medium tracking-tight text-lg text-ink'>Languages</h3>
          </div>
          <div className='flex flex-wrap gap-x-6 gap-y-2'>
            {LANGUAGES.map(lang => (
              <span key={lang} className='text-sm text-gray1'>
                {lang}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
